var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 22,
    viewBox: "0 0 110 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_7047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6858 21.9811L20.1013 0.172852H23.125L27.0436 17.864L30.991 0.172852H34.0147L34.4302 21.9811H31.9275L31.6878 6.13171L27.9258 21.9811H26.187L22.4538 6.13171L22.214 21.9811H19.6858Z",
    fill: "url(#paint0_linear_70_7047)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2917 21.9811V0.172852H43.7473C45.9943 0.172852 47.6436 0.625423 48.6888 1.52742C49.7372 2.42942 50.2614 3.90342 50.2614 5.94628C50.2614 8.75285 49.3472 10.45 47.519 11.0377L50.6897 21.9811H47.6916L44.7765 11.748H42.3825V21.9811H39.2917ZM42.3825 9.56371H43.546C44.8916 9.56371 45.8537 9.30285 46.429 8.78114C47.0043 8.25942 47.292 7.31342 47.292 5.94628C47.292 4.62314 47.0459 3.69285 46.5505 3.15857C46.0551 2.62428 45.1217 2.35714 43.7473 2.35714H42.3825V9.56371Z",
    fill: "url(#paint1_linear_70_7047)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2357 21.9811V2.42314H53.1829V0.172852H64.2324V2.42314H60.3265V21.9811H57.2357Z",
    fill: "url(#paint2_linear_70_7047)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.781 21.9811V0.172852H71.881V20.4443H78.1936V21.9843H69.781V21.9811Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7991 21.9811V0.172852H83.8607V21.9811H81.7991Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2302 21.9811V0.172852H97.2305V1.71285H91.3302V9.90628H96.2396V11.4337H91.3302V21.9843H89.2302V21.9811Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.251 21.9811V0.172852H109.265V1.75057H103.351V9.91885H108.194V11.4463H103.351V20.4443H109.332V21.9843H101.251V21.9811Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7783 11.1697L11.3628 10.8963L11.366 10.8931L8.51493 9.02L8.50854 9.02314L6.99351 8.03C5.75335 7.216 5.60952 5.94314 5.89399 5.016C6.17846 4.09514 7.01268 3.11143 8.50534 3.11143C9.998 3.11143 10.8354 4.09514 11.1199 5.01914C11.1998 5.27371 11.2445 5.55343 11.2445 5.84257C11.2445 6.41143 11.0656 7.018 10.6053 7.53343L13.2358 9.284C14.3577 7.84457 14.7221 5.97143 14.15 4.11714C13.3797 1.61543 11.1646 0 8.50854 0C5.85244 0 3.63742 1.61543 2.86712 4.11714C2.18312 6.336 2.84155 8.59257 4.54197 10.0886L8.8889 13.0146L10.0204 13.7563C11.2637 14.5703 11.4044 15.84 11.1199 16.7671C10.8354 17.688 10.0012 18.6749 8.50534 18.6749C7.01268 18.6749 6.17526 17.6911 5.89399 16.7671C5.66066 16.016 5.715 15.0229 6.42137 14.2403L3.80363 12.4709C3.02054 13.464 2.59863 14.6646 2.59863 15.928C2.59863 16.5 2.68493 17.0877 2.86392 17.6691C3.63422 20.1709 5.84924 21.7863 8.50534 21.7863C11.1646 21.7863 13.3765 20.1709 14.15 17.6691C14.9203 15.1737 13.9901 12.6186 11.7783 11.1697Z",
    fill: "url(#paint3_linear_70_7047)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_70_7047",
    "mask-type": "luminance",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -4,
    width: 20,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4175 -3.77044L-0.000732422 5.01987L8.00442 14.1931L18.4226 5.40275L10.4175 -3.77044Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_70_7047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7783 11.2074L11.3628 10.934L11.366 10.9308L8.51493 9.0577L8.50854 9.06085L6.99351 8.0677C5.75335 7.2537 5.60952 5.98085 5.89399 5.0537C6.17846 4.13285 7.01268 3.14913 8.50534 3.14913C9.998 3.14913 10.8354 4.13285 11.1199 5.05685C11.1998 5.31142 11.2445 5.59113 11.2445 5.88028C11.2445 6.44913 11.0656 7.05571 10.6053 7.57113L13.2358 9.3217C14.3577 7.88228 14.7221 6.00913 14.15 4.15485C13.3797 1.65313 11.1646 0.0377045 8.50854 0.0377045C5.85244 0.0377045 3.63742 1.65313 2.86712 4.15485C2.18312 6.3737 2.84155 8.63028 4.54197 10.1263L8.8889 13.0523L10.0204 13.794C11.2637 14.608 11.4044 15.8777 11.1199 16.8048C10.8354 17.7257 10.0012 18.7126 8.50534 18.7126C7.01268 18.7126 6.17526 17.7288 5.89399 16.8048C5.66066 16.0537 5.715 15.0606 6.42137 14.278L3.80363 12.5086C3.02054 13.5017 2.59863 14.7023 2.59863 15.9657C2.59863 16.5377 2.68493 17.1254 2.86392 17.7068C3.63422 20.2086 5.84924 21.824 8.50534 21.824C11.1646 21.824 13.3765 20.2086 14.15 17.7068C14.9203 15.2114 13.9901 12.6563 11.7783 11.2074Z",
    fill: "url(#paint4_linear_70_7047)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70_7047",
    x1: 27.0567,
    y1: 0.17282,
    x2: 27.0567,
    y2: 21.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C8D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A8CA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_70_7047",
    x1: 44.9895,
    y1: 0.17282,
    x2: 44.9895,
    y2: 21.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C8D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A8CA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_70_7047",
    x1: 58.7085,
    y1: 0.17282,
    x2: 58.7085,
    y2: 21.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C8D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A8CA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_70_7047",
    x1: 2.59966,
    y1: 10.8972,
    x2: 14.4184,
    y2: 10.8972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C8D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A8CA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_70_7047",
    x1: 2.59966,
    y1: 10.9349,
    x2: 14.4184,
    y2: 10.9349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9F5D",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_7047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.312,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6b0a273f2d2ec703175b7dc640fa83df.svg";
export { ForwardRef as ReactComponent };